import { Component, OnInit } from '@angular/core';
import { AppInformationService, GenesisUnitOfWork } from 'app/core/core.module';
import { FeeType, SalesRep } from 'app/core/model/entity-model';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-fee-type-dialog',
    templateUrl: './fee-type-dialog.component.html',
    styleUrls: ['./fee-type-dialog.component.scss'],
    standalone: false
})
export class FeeTypeDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    feeType: FeeType;
    displayOrder: number;
    validationGroup: 'feeTypeValidationGroup';
    baseTypes = ['Percentage Based', 'Amount Based'];

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService) {}

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        if (!this.feeType) {
            this.feeType = this.uow.feeTypes.createEntity({
                displayOrder: this.displayOrder,
            }) as FeeType;
        }
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    typeChanged = (e) => {
        const selectedType = e.value;
        if (selectedType === 'Percentage Based') {
            this.feeType.percentageBased = true;
            this.feeType.amountBased = false;
        } else if (selectedType === 'Amount Based') {
            this.feeType.amountBased = true;
            this.feeType.percentageBased = false;
        }
    };

    validate() {
        const groupConfig = validationEngine.getGroupConfig('feeTypeValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('feeTypeValidationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
